module.exports = "<section class=\"container-fluid no-breadcrumbs chapter\">\r\n    <article class=\"article\">           \r\n            <app-contrato [contratoid]=\"contrato\"></app-contrato>     \r\n    </article>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/home/home.component.html
// module id = ../../../../../src/app/components/home/home.component.html
// module chunks = main